import React from 'react'
import { connect } from 'react-redux'
import { fetchStation, fetchPaxCountByStation } from '../actions/remote_api'
import { info } from '../storage'

class KioskCapacityLabel extends React.Component {
  componentDidMount() {
    this.fetchStation()
    this.fetchActivePaxCount()
  }

  fetchActivePaxCount() {
    const { stationId } = info()
    this.props.fetchPaxCountByStation(stationId)
  }

  fetchStation() {
    const { stationId } = info()
    this.props.fetchStation(stationId)
  }

  renderCapacity() {
    const { activePaxCount, stationCapacity } = this.props
    const isActiveServiceTxnCountFetched = activePaxCount !== undefined
    if (this.hasCapacity() && isActiveServiceTxnCountFetched) {
      return `${activePaxCount}/${stationCapacity}`
    }
    return isActiveServiceTxnCountFetched ? `${activePaxCount}` : null
  }

  isLimitExceed() {
    const { activeServiceTxnCount, stationCapacity } = this.props
    if (!this.hasCapacity()) return false
    return activeServiceTxnCount > stationCapacity
  }

  hasCapacity() {
    return this.props.stationCapacity !== undefined
  }

  render() {
    const capacity = this.renderCapacity()
    const isLimitExceed = this.isLimitExceed()
    const hasCapacity = this.hasCapacity()

    if (capacity === null) return null

    const bgColor = isLimitExceed ? 'bg-red-500' : 'bg-gray-100'
    const textColor = isLimitExceed ? 'text-white' : 'text-gray-700'
    const fontSize = hasCapacity ? 'text-xs' : 'text-base'

    return (
      <div
        className={`inline-flex items-center justify-center rounded-full font-bold ${bgColor} ${textColor} ${fontSize} px-3 py-1.5 min-w-[3rem] shadow-sm`}
      >
        {capacity}
      </div>
    )
  }
}

export default connect(
  ({ fetch: { serviceTxnCount, activePaxCount, station } }) => ({
    activePaxCount:
      activePaxCount && activePaxCount.single
        ? activePaxCount.single.paxCount
        : undefined,
    stationCapacity:
      station && station.single ? station.single.capacity : undefined,
  }),
  {
    fetchStation,
    fetchPaxCountByStation,
  },
)(KioskCapacityLabel)
